<main class="main-content {{classList}}">
  <article *ngFor="let item of items$ | async; let i = index" class="item"
    [routerLink]="item.elementTypeID && item.elementTypeID === COVER_ELEMENT_TYPE_CONTENTS ? [('/' + item.url + '/' + item[itemKeyName] + '/' + (item.title | slug))] : item.url">

    <img *ngIf="item.image" class="image" [src]="item.image" [alt]="item.title" loading="lazy"
      (error)="image.src='../../../../assets/img/default.webp'" #image>

    <header class="header">
      <p class="category">{{item.categoryName}}</p>
      <p class="author">{{item.observatoryName}}</p>
      <time *ngIf="item.date">{{item.date | date:'mediumDate'}}</time>
    </header>

    <h4 class="title num-lines-4">{{item.title}}</h4>

    <!-- <label *ngIf="item.isNew" class="new-badge">Nuevo</label> -->

  </article>
</main>